import React from 'react'
import { Tabs } from 'antd';
import Employment from './Employment';
import Documents from './Documents';
import Guarantor from './Guarantor';
const { TabPane } = Tabs;

function DocumentUpload() {
	
  return (
  <>
    <div className='container'>
	<br/>
	<p class='green-text subheader'>My Dashboard</p>
	
	<br/>
      <Tabs defaultActiveKey="1" >
        <TabPane tab="Employment status" key="1">
		<br/>
		  <Employment />
        </TabPane>
        <TabPane tab="Documents" key="2">
          <br/>
		  <Documents />
        </TabPane>
        <TabPane tab="Guarantor" key="3">
          <br/>
		  <Guarantor />
        </TabPane>
		
      </Tabs>
	  <div>
	  <a class='white-text save-btn' href="profile">Save</a> 
	  </div>
    </div>
	</>
  )
}

export default DocumentUpload